module.exports = __webpack_public_path__ + "media/images/expert__inka-grings-b675caece3407a77c639ae101c1c5391.png";